export default "__VITE_ASSET__1aed2b9a__"